module.exports = __webpack_public_path__ + "static/media/cuenta.e7eed094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/datos/cuenta.jpg
// module id = 577
// module chunks = 0